
import {Commessa} from '../models/commessa';
import {Statolavorazione} from '../models/statolavorazione';

export class Lavorazione {
    Codice: number;
    Nome: string;
    Statolavorazione: Statolavorazione;
    Commessa: Commessa;
    Codicecommessa: number;
    Codicestatolavorazione: number;
    Importo: number;
    Sconto: number;
    Subtotale: number;

  constructor(){
    this.Codice=0;
    this.Nome='';
    this.Statolavorazione=new Statolavorazione();
    this.Commessa=new Commessa();
    this.Codicecommessa=0;
    this.Codicestatolavorazione=0;
    this.Importo=0;
    this.Sconto=0;
    this.Subtotale=0;
  }
}
